export default class OnboardingChecklistItemModel {
  constructor(obj) {
    obj = obj || {};

    this.id = obj.id;
    this.title = obj.title;
    this.description = obj.description;
    this.route = obj.route;
    this.actionLabel = obj.actionLabel;
    this.displayOrder = obj.displayOrder;
    this.isCompleted = obj.isCompleted;
    this.isMandatory = obj.isMandatory;
    this.content = obj.content;
    this.icon = obj.icon;
  }
}
